import { useTranslation } from "react-i18next";
import { Box, IconButton, Stack } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useNavigation } from "../NavigationProvider";
import LocationPicker from "../../../common/inputs/LocationPicker";
import { useCallback, useState } from "react";
import { Menu as MenuIcon, ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useDevice } from "../../../../providers/DeviceProvider";
import { useNavigate } from "react-router";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      zIndex: 10,
    },
    picker: {
      boxShadow: "3px 10px 3px 0px rgba(0, 0, 0, 0.00), 2px 6px 3px 0px rgba(0, 0, 0, 0.01), 1px 4px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.09), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)",
      background: "#FFF",
      borderRadius: theme.spacing(1),
    },
    menuButton: {
      borderRadius: theme.spacing(1),
      background: "#FFF",
      boxShadow: "3px 10px 3px 0px rgba(0, 0, 0, 0.00), 2px 6px 3px 0px rgba(0, 0, 0, 0.01), 1px 4px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.09), 0px 0px 1px 0px rgba(0, 0, 0, 0.10)"
    }
  })
);

export default function DestinationSelector(props) {
  const { className, backButton } = props;
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { setDestination } = useNavigation();
  const navigate = useNavigate();
  const { slim, setSidebarOpen } = useDevice();
  const [location, setLocation] = useState(null);


  const onNavButton = useCallback(() => {
    if (!!backButton) {
      navigate(backButton, { relative: "path" });
    } else {
      setSidebarOpen(true);
    }
  }, [backButton, setSidebarOpen, navigate]);


  const onChange = useCallback((loc) => {
    setLocation(loc);
    if (loc?.coordinates?.length === 2) {
      setDestination(loc);
    }
  }, [setDestination]);


  return (
    <Stack className={`${classes.root} ${className || ""}`} direction="row" spacing={1}>
      {
        !!slim ? (
          <Box className={classes.menuButton}>
            <IconButton color="primary" onClick={onNavButton} >
              {
                !!backButton ? (
                  <ArrowBackIcon fontSize="large" />
                ) : (
                  <MenuIcon fontSize="large" />
                )
              }
            </IconButton>
          </Box>
        ) : null
      }

      <LocationPicker
        className={classes.picker}
        label={t("entity:location:address")}
        value={location}
        onChange={onChange}
      />
    </Stack>
  )
}

